import { Box, Skeleton, Stack } from "@mui/material";

// Sibling to PerformanceTable.tsx - shown while the currently selected
// period (Daily/Weekly/Monthly) is fetching, so switching periods never
// flashes another period's stale data before the real rows arrive.
export default function PerformanceTableSkeleton() {
  return (
    <Stack spacing={1.75}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.75 }}>
        <Skeleton variant="text" width={220} height={28} sx={{ flex: 1 }} />
        <Skeleton variant="rounded" width={180} height={32} />
      </Box>
      <Skeleton variant="rounded" height={320} />
    </Stack>
  );
}
